import { SellerInventory } from "../../../../reducers/componentSearch";
import { Formik } from "formik";
import { FormContainer } from "../../../../constants/Styles";
import FormikFormLine from "../../../formik-form-components/FormikFormLine";
import FormikNumberInput from "../../../formik-form-components/FormikNumberInput";
import { FieldTypes } from "../../../formik-form-components/FormikFormLine/constants";
import React from "react";
import * as Yup from "yup";
import {
  todayInPhillyToDateInputString,
  twentyFourHourToTwelveHour,
} from "../../../../utils/valueFormatting";
import { useCustomAlert } from "../../../../utils/hooks/alerts";
import useApproveDistributorForPart from "../../../../utils/hooks/inventory/approveDistributorForPart";
import { useFlashPCBSettings } from "../../../../utils/hooks/commonly-stored/flashPCBSettings";
import LoadingIcon from "../../../common/LoadingIcon";
import { ApproveSellerContainer } from "../PartDrawerStyles";
import Button from "../../../common/Button";

const APPROVE_DISTRIBUTOR_SCHEMA = Yup.object().shape({
  leadTime: Yup.number().min(0),
  expiration: Yup.date().min(new Date(), "Please choose future date"),
});

interface ApproveDistributorValues {
  leadTime: number;
  expiration: string;
}

export default function ApproveVirtualInventory({
  partId,
  sellerInventory,
  onFinishedEditing,
}: {
  partId: string;
  sellerInventory: SellerInventory;
  onFinishedEditing: () => void;
}) {
  const flashPCBSettings = useFlashPCBSettings();
  const customAlert = useCustomAlert();
  const errorHandler = (errorMessage: string) => {
    customAlert(errorMessage);
    onFinishedEditing();
  };
  const { approveDistributor } = useApproveDistributorForPart(
    onFinishedEditing,
    errorHandler,
  );

  const submitApproval = (values: ApproveDistributorValues) => {
    approveDistributor(
      sellerInventory,
      partId,
      values.leadTime,
      values.expiration,
    );
  };

  if (flashPCBSettings === null) {
    return <LoadingIcon />;
  }

  return (
    <Formik
      initialValues={{
        leadTime: 10,
        expiration: todayInPhillyToDateInputString(30),
      }}
      onSubmit={submitApproval}
      validationSchema={APPROVE_DISTRIBUTOR_SCHEMA}
    >
      {({ handleSubmit, isValid }) => {
        return (
          <ApproveSellerContainer>
            <FormContainer>
              <FormikNumberInput
                name="leadTime"
                label="Lead time for part delivery"
              />
              <FormikFormLine
                name="expiration"
                label={`This approval expires at ${twentyFourHourToTwelveHour(flashPCBSettings.local_lead_time_eod)} on`}
                type={FieldTypes.date}
                isRequired={true}
              />
              <Button
                isSmallSize
                label={"Approve distributor"}
                onClick={handleSubmit}
                disabled={!isValid}
              />
            </FormContainer>
          </ApproveSellerContainer>
        );
      }}
    </Formik>
  );
}
